<template>
  <PageHeader title="Stormwater reports" subtitle="Manage reports for your projects">
    <router-link :to="{ name: 'new-report' }" class="router-button">
      <AppIcon color="white" type="plus" class="mr-5px" /> Add report
    </router-link>
  </PageHeader>

  <TableLayout>
    <ReportsEmptyState v-if="!reports.length" />

    <ReportsTable v-else :reports="reports" :back-route="{ name: 'reports' }" />
  </TableLayout>
</template>

<script setup>
import { onMounted } from "vue";
import { AppIcon } from "@/components/ui";

import { useReports } from "@/composables/useReports";
import PageHeader from "@/components/PageHeader.vue";
import TableLayout from "@/layouts/TableLayout.vue";
import ReportsEmptyState from "@/views/ReportsView/components/ReportsEmptyState.vue";
import ReportsTable from "@/views/ReportsView/components/ReportsTable.vue";

const { reports, fetchReports } = useReports();

onMounted(fetchReports);
</script>
